// This file serves as a central location for all configuration variables related to Reports
import UniversalTableConfig from "./UniversalTableConfig.js";

// Helper Function to Create Dictionary Mapping in Label, Value Format
const arrayToLabelValueDict = (array) => {
  return array?.map((item) => {
    return {
      label: item,
      value: item,
    };
  });
};
// Reports Accordion Configuration
export const reportsAccordionConfig = {
  introduction: true,
  custom: true,
  energy: true,
  risk: true,
  strategy: true,
  target: true,
  challenges: true,
};
// Historical Reports
// Reports Table Columns
export const reportsColumns = ["dateDownload", "timePeriod", "reportType"];
// Reports Table Config
export const reportsTableConfig = () => {
  // Columns Configuration
  const columnsConfig = UniversalTableConfig(reportsColumns);
  return columnsConfig;
};

// New Report Generation

// ------------------------------------ HEADER SECTION ------------------------------------
// Radio options for the RadioGroup Component in Download Reports Group
const downloadReportOptions = ["Month", "Quarter", "YTD", "Year", "Custom"];
export const downloadReportsRadioOptions = arrayToLabelValueDict(
  downloadReportOptions
);

// Dropdown options for SelectDropdown Component in Download Reports Group when Quarter is Selected
export const monthToQuarterMap = {
  "01": "Q1",
  "02": "Q1",
  "03": "Q1",
  "04": "Q2",
  "05": "Q2",
  "06": "Q2",
  "07": "Q3",
  "08": "Q3",
  "09": "Q3",
  10: "Q4",
  11: "Q4",
  12: "Q4",
};
// Dropdown options for SelectDropdown Component in Download Reports Group when Month is Selected
const downloadReportMonthOptions = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const downloadReportMonthOptionsShort = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const downloadReportsMonthDropdownOptions =
  downloadReportMonthOptions?.map((item, index) => {
    return {
      label: item,
      value: downloadReportMonthOptionsShort[index],
    };
  });

// Yes, No, Other Dropdown Fields
const yesNoOtherOptions = ["Yes", "No", "Other"];
export const yesNoOtherDropdownOptions =
  arrayToLabelValueDict(yesNoOtherOptions);

// Const: Energy Options For the Dropdown
export const energyOptions = [
  "consumption_fuel",
  "consumption_electricity",
  "generation_all",
];
// -------------------------------- INTRODUCTION SECTION --------------------------------
// Introduction Questions Breakdown
const IntroReportQuestionConfig = [
  "Company Name",
  "Provide details for the person that has signed off (approved) your CDP climate change response.",
  "A.1. Give a general description and introduction to your organization.",
  "A.2. State the start and end date of the year for which you are reporting data.",
  "A.3. Select the countries/areas in which you operate.",
  "A.4. Select the option that describes the reporting boundary for which climate-related impacts on your business are being reported. Note that this option should align with your chosen approach for consolidating your GHG inventory.",
  "A.5. For which transport modes will you be providing data?",
  "A.6. Does your organization have an ISIN code or another unique identifier (e.g., FMC No., DOT No., SCAC No.,etc.)?",
  "A.7. Is there board-level oversight of climate-related issues within your organization?",
];
// Job Title Select Dropdown Options
const jobReportOptions = [
  "Chief Executive Officer (CEO)",
  "Chief Operating Officer (COO)",
  "Chief Financial Officer (CFO)",
  "Chief Technology Officer (CTO)",
  "President",
  "Director of Operations",
  "Director of Logistics",
  "Sustainability Officer",
  "Fleet Manager",
  "Other",
];
export const jobTitleReportDropdownOptions =
  arrayToLabelValueDict(jobReportOptions);
// Countries of Operation Select Dropdown Options
const countryOfOperationsOptions = ["United States of America", "Canada"];
export const countryOfOperationsDropdownOptions = arrayToLabelValueDict(
  countryOfOperationsOptions
);
// Reporting Boundary Radio Item Options
const reportingBoundaryOptions = [
  `Operational boundary\nReporting on climate-related impacts within the organizational boundaries of our company, including facilities, operations, and/or subsidiaries, in alignment with GreenIRR's chosen approach for consolidating your GHG inventory. This includes fleet emissions and scope 2 emissions for buildings owned or controlled by our company. Additionally, data related to lifecycle emissions of fuels used by company vehicles and the well-to-tank portion of fuel consumed by owned or controlled vehicles.`,
  `Organizational boundary\nReporting on climate-related impacts within the overall organizational boundaries of your company, including its operational and financial control, in alignment with GreenIRR's chosen approach for consolidating your GHG inventory.`,
  `Value chain boundary\nReporting on climate-related impacts across our value chain, including Scope 3 categories 4 and 9 - upstream and downstream transportation and distribution. In particular, emissions generated from trucking carriers both upstream and downstream of our company, in alignment with GreenIRR's approach for consolidating your GHG inventory.`,
  `Geographical boundary\nReporting on climate-related impacts within specific geographical regions or markets relevant to our business, in alignment with GreenIRR's chosen approach for consolidating your GHG inventory. The exact geographical boundary for which operations were conducted in that will be reported, can be found in A.3.`,
];
export const reportingBoundaryRadioItemOptions = arrayToLabelValueDict(
  reportingBoundaryOptions
);
// Transport Modes Radio Item Options
const transportModesOptions = [
  "Heavy-Duty Vehicles (HDVs)",
  "Medium-Duty Vehicles (MDVs)",
  "Light-Duty Vehicles (LDVs)",
];
export const transportModesChecklistOptions = arrayToLabelValueDict(
  transportModesOptions
);
// ISIN Code Dropdown Options
const ISINcodeOptions = [
  "USDOT Number",
  "MC Number",
  "FMC Number",
  "Not Applicable",
];
export const ISINcodeDropdownOptions = arrayToLabelValueDict(ISINcodeOptions);

// Board Level Oversight Radio Options
const boardLevelOversightOptions = [
  "Yes - Within our organization, climate-related issues are actively overseen at the board level.\nOur board of directors is deeply engaged in discussions and decision-making regarding our environmental impact, sustainability efforts, and strategies for combating climate change. This demonstrates our firm commitment to environmental responsibility and ensures that we address climate-related risks and opportunities with top-level governance.\nOur board of directors plays a strong role in setting the strategic direction for our organization's environmental initiatives, including efforts to reduce our fleet's carbon footprint. Executive management works closely with the board to develop and implement sustainability strategies that align with our business objectives while mitigating environmental impacts.\nOperational decisions related to our fleet, such as adopting fuel-efficient technologies, optimizing routing and scheduling to minimize empty miles, and investing in alternative fuels or electric vehicles, are thoroughly evaluated by both executive management and the board. These decisions are assessed not only for their potential cost savings and operational efficiencies but also for their environmental benefits and contribution to our sustainability goals.\nThe board provides oversight and guidance on the implementation of these initiatives, ensuring that they are aligned with our long-term sustainability vision and that appropriate resources are allocated for their success. Executive management reports regularly to the board on the progress of our sustainability efforts, allowing for ongoing evaluation and adjustment of our strategies as needed to achieve our carbon reduction targets.\nThis integrated approach to sustainability governance ensures that our commitment to reducing our fleet's carbon footprint is reflected in both our strategic priorities and our day-to-day operations, driving continuous improvement and demonstrating our leadership in environmental stewardship within the trucking industry.",
  "No - Currently, our organization's board does not have a specific focus on climate-related issues.\nHowever, this presents an opportunity for us to further integrate sustainability considerations into our governance structure. While climate-related matters may not be directly overseen at the board level, our organization remains committed to environmental responsibility and recognizes the importance of addressing climate change.\nOperational decisions within our trucking company are guided by our commitment to sustainability, even if they are not directly managed at the board level. Our executive management actively explores opportunities to reduce our fleet's carbon footprint through initiatives such as adopting fuel-efficient technologies, optimizing routes for efficiency, and exploring alternative fuels or electric vehicles.\nAlthough there may not be formal board oversight, executive management is dedicated to integrating sustainability into our decision-making processes. They regularly assess the environmental impact of our operations and seek ways to minimize our carbon emissions while balancing economic considerations.\nLooking ahead, there is potential for our organization to evolve by incorporating climate-related considerations into our governance structure, potentially through the establishment of dedicated committees or by increasing environmental representation within the board. This proactive approach will further reinforce our commitment to sustainability and position us as leaders in environmental stewardship within the trucking industry.",
  "Other",
];
export const boardLevelOversightRadioOptions = arrayToLabelValueDict(
  boardLevelOversightOptions
);

// ----------------------------- RISKS & OPPORTUNITIES SECTION -----------------------------
// Risks & Opportunities Questions Breakdown
const RisksAndOpportunitiesBreakdownConfig = [
  "B.1. Does your organization have a process for identifying, assessing, and responding to climate-related risks and opportunities?",
  "B.2. Have you identified any inherent climate-related risks with the potential to have a substantive financial or strategic impact on your business?",
  "B.3. Did you incur capitalized costs and charges (excluding recoveries), attributable to severe weather events and other natural conditions?",
  "B.4. Did you incur expenses and losses, attributable to severe weather events and other natural conditions?",
  "B.5. As a result of any transition plan, do you plan to accelerate the replacement of any assets or reduce the estimated useful lives of those assets from the originally determined years?",
  "B.6. Are there physical transition risks that materially impact or are reasonably likely to have a material impact over the short-term?",
  "B.7. Describe where and how climate-related risks and opportunities have influenced your financial planning.",
  "B.8 Does the organization have any operations or joint ventures involving state ownership or a mix of private and state ownership?",
  "B.2b. If not, why do you not consider your organization to be exposed to climate-related risks with the potential to have a substantive financial or strategic impact on your business?",
];
// Climate Related Risk Radio Options
const clientRiskOptions = [
  "Yes - We already have a well-established process in place for identifying, assessing, and responding to climate-related risks and opportunities, and are actively managing our climate-related impacts.\nOur assessment process begins with a thorough evaluation of our fleet operations, focusing on factors such as fuel consumption, vehicle efficiency, and maintenance practices. We also consider regulatory requirements related to emissions standards and environmental compliance to ensure that we meet or exceed mandated guidelines.\nAdditionally, we conduct risk assessments to anticipate how climate-related factors, such as extreme weather events or changing regulatory landscapes, may impact our operations. In response, we develop proactive strategies to mitigate risks and seize opportunities. This may involve investing in technology solutions to improve fuel efficiency, implementing driver training programs to promote eco-friendly driving practices, or exploring alternative fuel options to reduce emissions.\nBy staying proactive and responsive to emerging climate-related challenges, we not only reduce our environmental footprint but also enhance our operational efficiency and resilience. Our commitment to proactive climate risk management ensures that we are well-prepared to adapt to changing environmental conditions and market dynamics. This approach not only benefits the environment but also strengthens our competitiveness and ability to provide reliable and sustainable transportation solutions to our customers.",
  "No - Currently, our organization does not have a formal process for identifying, assessing, and responding to climate-related risks and opportunities.\nWhile we acknowledge this gap, We are committed to addressing it to better serve our customers and the environment. We understand the importance of climate resilience in our industry and are actively exploring ways to develop a structured approach. As part of this commitment, We are engaging with stakeholders, seeking expert guidance, and evaluating industry best practices to ensure that our future processes are robust, effective, and tailored to meet the needs of our customers.",
  "No - We intend to in the future.\nWe do not currently have a process for addressing climate-related risks and opportunities. However, we are committed to developing such a process in the future, and will take a proactive approach toward climate risk management and sustainability. Our future plans include developing a structured framework for identifying, assessing, and responding to climate risks and opportunities within our trucking operations. This will involve engaging with industry experts, leveraging best practices, and integrating climate considerations into our decision-making processes.",
];
export const clientRiskRadioOptions = arrayToLabelValueDict(clientRiskOptions);
// Exposed Risk Radio Options
const exposedRiskOptions = [
  "Not evaluated yet.\nOur organization has not yet conducted a formal evaluation of climate-related risks. However, we recognize the importance of assessing these risks and are committed to conducting a comprehensive evaluation in the near future.",
  "Evaluated, and have found no substantive climate-related risks.",
];
export const exposedRiskRadioOptions =
  arrayToLabelValueDict(exposedRiskOptions);
// Capitalized Costs Radio Options
const capitalizedCostsOptions = [
  "Yes, the aggregate amount of capitalized costs and charges is ≥ 1% of the absolute value of stockholders' equity or deficit at the end of the relevant fiscal year.",
  "No, the aggregate capitalized costs and charges for the fiscal year were < $500,000.",
];
export const capitalizedCostsRadioOptions = arrayToLabelValueDict(
  capitalizedCostsOptions
);
// Expenses and Losses Radio Options
const expensesLossesOptions = [
  "Yes, aggregate amount of expenditures expensed as incurred and losses is ≥ 1% of the absolute value of income or loss before income tax expense or benefit for the relevant fiscal year.",
  "No, the aggregate expenses and losses for the fiscal year were < $100,000.",
];
export const expensesLossesRadioOptions = arrayToLabelValueDict(
  expensesLossesOptions
);
//  Physical Transition Risks Radio Options
const physicalTransitionRiskOptions = [
  `Yes - We anticipate that extreme weather events, such as hurricanes and floods, may pose significant risks to our operations in the short-term.\nThese events could lead to disruptions in deliveries, increased maintenance costs, and damage to our facilities. Depending on the extremity of the weather, it is possible that our driver behavior would be altered in order to remain comfortable or safe. This could mean increased idling or non-standard routes, that significantly increase our operating costs.`,
  `No - Based on our current assessment and projections, we do not anticipate any physical transition risks materially impacting our operations over the short-term.\nNevertheless, we remain prepared and continue to invest in resilience measures to mitigate potential risks and ensure the continuity of our operations in the face of climate uncertainties.`,
  "Other",
];
export const physicalTransitionRiskRadioOptions = arrayToLabelValueDict(
  physicalTransitionRiskOptions
);
// Financial Planning Impact - Products & Services
export const financialPlanningImpactPandSOptions = [
  "Climate-related risks and opportunities have led us to invest in fuel-efficient and low-emission vehicles, reducing long-term operating costs and improving our environmental sustainability.",
  "We have made some adjustments to our maintenance schedules and route planning to mitigate climate-related risks, but it has not had a significant financial impact.",
  "We have not yet incorporated climate-related considerations into our financial planning for products and services, but we are exploring potential opportunities.",
  "Climate-related factors have not influenced our financial planning for products and services, as they are not relevant to our business operations.",
  "Other",
];
export const financialPlanningImpactPandSChecklistOptions =
  arrayToLabelValueDict(financialPlanningImpactPandSOptions);
// Financial Planning Impact - Investment
export const financialPlanningImpactInvestmentOptions = [
  "We have made investments in fuel-efficient vehicles, new vehicle models, or electric vehicles to reduce operating costs and carbon emissions.",
  "We have invested in a carbon accounting or carbon management software to better understand our fleet emissions, large sources of emissions within our operations, and exert better control over our carbon footprint.",
  " We are considering investing in climate-conscious practices for fleet management, but no significant financial changes have been made yet.",
  "Climate-related factors have not significantly influenced our financial planning, as it's not yet a top priority for our fleet operations.",
  "Other",
];
export const financialPlanningImpactInvestmentChecklistOptions =
  arrayToLabelValueDict(financialPlanningImpactInvestmentOptions);
// Financial Planning Impact - Operations
export const financialPlanningImpactOperationsOptions = [
  "We have increased our route optimization and efficiency to decrease climate-related risks associated with excess emissions.",
  "We have implemented anti-idling technology, driver training programs, or generally taken action to reduce idle-time - significantly reducing fuel costs and emissions associated with idling, which positively impacts our bottom line.",
  "We are considering implementing climate-conscious practices for fleet management in our operations, but no significant financial changes have been made yet.",
  "Other",
];
export const financialPlanningImpactOperationsChecklistOptions =
  arrayToLabelValueDict(financialPlanningImpactOperationsOptions);
// Joint Ventures
export const jointVenturesOptions = [
  "Yes, there are operations or joint ventures involving state ownership.",
  "Yes, there are operations or joint ventures involving a mix of private and state ownership.",
  "No, all operations are privately owned with no state involvement.",
  "Not applicable, as the organization does not have joint ventures or collaborative operations.",
];
export const jointVenturesRadioOptions =
  arrayToLabelValueDict(jointVenturesOptions);

// ----------------------------------- STRATEGY SECTION -----------------------------------
// Strategy Questions Breakdown
const StrategyBreakdownConfig = [
  "C.1. Does your organization's strategy include a climate transition plan that aligns with a 1.5°C world?",
  "C.2. Does your organization use climate-related scenario analysis to inform its strategy?",
  "C.3. What relevant scenarios, parameters, or assumptions were used or will be used in your scenario analysis?",
  "C.4. Have you purchased or developed any carbon offsets?",
  "C.5. Are the carbon offsets you have purchased or developed verified or certified by an external authority?",
  "C.6. Have the carbon offsets you have purchased or developed been approved by a recognized GHG program?",
  "C.7. Have other contractual instruments aside from offsets been utilized by your organization?",
  "C.8. Have any reductions from sources within your inventory boundary been sold or transferred as offsets to third parties?",
];
// Climate Transition Plan Options
const climateTransitionPlanoptions = [
  "Yes - Our organization's strategy includes a comprehensive climate transition plan that is aligned with a 1.5°C world.\nWe have integrated ambitious targets and initiatives into our strategic planning process to achieve alignment with a 1.5°C pathway. Our climate transition plan encompasses a range of measures aimed at reducing greenhouse gas emissions. By aligning our strategy with a 1.5°C world, we are not only mitigating climate risks but also positioning ourselves for long-term success in a rapidly changing global landscape.",
  "No - Our organization's strategy does not currently include a climate transition plan aligned with a 1.5°C world.\nWhile we recognize the importance of addressing climate change, our strategy has not yet integrated specific plans or targets aimed at achieving alignment with a 1.5°C pathway.",
  "No - but we intend to implement one in the next three years.",
  "Other",
];
export const climateTransitionPlanRadioOptions = arrayToLabelValueDict(
  climateTransitionPlanoptions
);
// Climate Related Scenario Analysis
const climateRelatedScenarioAnalysisOptions = [
  "Yes, we regularly use climate-related scenario analysis to inform our strategy.",
  "No, we do not use climate-related scenario analysis in our strategy development.",
  "We are in the process of considering climate-related scenario analysis for future strategy.",
  "We use climate-related scenario analysis occasionally, but it does not significantly influence our strategy.",
  "Other",
];
export const climateRelatedScenarioAnalysisRadioOptions = arrayToLabelValueDict(
  climateRelatedScenarioAnalysisOptions
);
// Relevant  Scenarios, Parameters, or Assumptions
export const relevantScenariosParametersAssumptionsOptions = {
  scenarios: [
    "Implementation of stricter emission regulations",
    "Increased frequency and severity of extreme weather events",
    "Rising temperatures leading to heatwaves and infrastructure stress",
    "Rapid advancements in electric vehicle (EV) technology.",
    "Development of alternative fuels (e.g., hydrogen, biofuels) and infrastructure.",
    "Increased demand for sustainable transportation solutions.",
    "Other",
  ],
  parameters: [
    "Magnitude and frequency of extreme weather events",
    "Adoption rates of electric vehicles and alternative fuel technologies.",
    "Infrastructure development for charging stations and alternative fueling stations.",
    "Willingness to pay higher premiums for sustainable transportation",
    "Other",
  ],
  assumptions: [
    "Increased costs for emissions compliance and regulatory requirements.",
    "Higher maintenance costs for vehicles due to wear and tear from extreme weather conditions.",
    "Potential disruptions to operations and supply chains from extreme weather events.",
    "Risks associated with infrastructure damage and route closures.",
    "Potential for competitive advantage by meeting or exceeding environmental standards.",
    "Investment requirements for transitioning to low-carbon technologies and infrastructure.",
    "Costs associated with upgrading fleets and implementing sustainability initiatives.",
    "Other",
  ],
};
export const relevantScenariosCheckboxOptions = arrayToLabelValueDict(
  relevantScenariosParametersAssumptionsOptions?.scenarios
);
export const relevantParametersCheckboxOptions = arrayToLabelValueDict(
  relevantScenariosParametersAssumptionsOptions?.parameters
);
export const relevantAssumptionsCheckboxOptions = arrayToLabelValueDict(
  relevantScenariosParametersAssumptionsOptions?.assumptions
);
// ----------------------------- TARGETS & REDUCTION SECTION -------------------------------
// Targets and Reduction Breakdown
const TargetsAndReductionBreakdownConfig = [
  "D.1. Did you have an emissions reduction target that was active in the reporting year?",
  "D.2. If not, why did you not have an active emissions target?",
];
// Emission Target Radio Options
const emissionTargetOptions = [
  `Yes\nWe have set an ambitious target to reduce emissions by [x%] by [x year]. By taking measurable progress and having a time-bound commitment we can continuously monitor our emissions performance against long-term goals. The target was set using [x year] as a base year.`,
  `No\nOur organization did not have an active emissions target during the reporting year. While emissions targets were not formally in place, we recognize the necessity and value of setting clear objectives to reduce our carbon footprint.`,
  `Other`,
];
export const emissionTargetRadioOptions = arrayToLabelValueDict(
  emissionTargetOptions
);
// Not Active Emission Targer
const notActiveEmissionTargetOptions = [
  "We are still in the process of gathering data and conducting a comprehensive emissions assessment to establish a baseline.",
  "We lack access to the necessary resources, technology, or expertise required to measure and reduce emissions effectively.",
  "Regulatory uncertainties and evolving climate policies have created hesitation in setting specific emission reduction targets.",
  "Climate-related goals and targets are not yet seen as a priority or market demand in our industry.",
  "Other",
];
export const notActiveEmissionTargetRadioOptions = arrayToLabelValueDict(
  notActiveEmissionTargetOptions
);
// ------------------------------------ ENERGY SECTION -------------------------------------
// Energy Questions Breakdown Configuration
const EnergyBreakdownConfig = [
  "E.1. Select which energy-related activities your organization has undertaken.",
  "Report your organization's energy consumption totals (excluding feedstocks) in MWh.",
  "Provide a breakdown by country/area of your non-fuel energy consumption in the reporting year.",
];

// Energy Related Activities Dropdown Questions
export const energyRelatedActivitiesDropdownQuestions = [
  "Consumption of fuel (excluding feedstocks)",
  "Consumption of purchased or acquired electricity",
  "Generation of electricity, heat, steam, or cooling",
];

// -------------------------------- CHALLENGES SECTION -------------------------------------
// Challenges Question Breakdown Config
const ChallengesBreakdownConfig = [
  "F.1. What challenges do you experience in measuring emissions?",
];

// Challenge Measuring Emissions Dropdown Options
const challengesMeasuringEmissionsOptions = [
  `We face considerable challenges in accurately measuring emissions within our organization. The practice of carbon accounting poses a significant obstacle, as it is still relatively new and lacks well-established standards. Our team encounters difficulties in navigating this evolving landscape, hindered by the absence of widely accepted methodologies and benchmarks, as well as a general understanding of the requirements.\nAdditionally, the shortage of expertise within our organization for measuring emissions compounds the issue, making it challenging to dedicate time and resources. Despite our commitment to sustainability, the complexities involved demand a concerted effort in acquiring the necessary knowledge and resources to effectively gauge and mitigate our emissions footprint.`,
  `Our organization encounters several challenges in measuring emissions, primarily stemming from inconsistent demand or support from customers. The difference in interest or urgency from our customer base poses difficulties in prioritizing and allocating resources towards comprehensive measurement initiatives.\nWithout a consistent demand for emission reports, we face uncertainty in gauging the level of investment needed for robust measurement systems and data collection processes.`,
  `Our organization faces challenges in measuring emissions due to changing regulatory requirements. Adapting to evolving regulations requires significant resources and expertise, and the uncertainty surrounding future changes complicates long-term planning.\nAdditionally, differing regulations across regions make standardization difficult. To address these challenges, we prioritize staying informed and engaging with regulators and industry stakeholders to ensure our practices align with evolving standards.`,
  "Other",
];
export const challengesMeasureEmissionsDropdownOptions = arrayToLabelValueDict(
  challengesMeasuringEmissionsOptions
);
// ------------------------------ ADDITIONAL FEATURES SECTION ------------------------------
// Checkbox Group - Additional Features Checkbox Options
const customReportOptions = [
  "Industry Carbon Rating",
  "Emissions per Vehicle",
  "Idle-time Emissions",
  "Total Idle-time",
  "Total Fuel Consumption",
  "Solution Marker",
  "Emissions Reduction Target",
  "Cost of Carbon",
];
export const checkboxGroupCustomReportOptions =
  arrayToLabelValueDict(customReportOptions);

// ------------------------------ ALL QUESTION CONFIGURATION ------------------------------
// Reports Question Configuration
export const reportQuestionConfig = {
  introduction: IntroReportQuestionConfig,
  riskAndOpportunities: RisksAndOpportunitiesBreakdownConfig,
  strategy: StrategyBreakdownConfig,
  targetsAndReduction: TargetsAndReductionBreakdownConfig,
  energy: EnergyBreakdownConfig?.slice(0, 1),
  challenges: ChallengesBreakdownConfig,
};
// ------------------------------ REPORTS SECTIONS ------------------------------
export const reportOptions = [
  "Introduction",
  "Risks & Opportunities",
  "Strategy",
  "Targets & Reduction",
  "Energy",
  "Challenges",
];
// ------------------------------ REPORT AUTOFILL API SECTIONING ------------------------------
const introKeys = [
  "approval",
  "company_description",
  "reporting_boundary",
  "transport_modes",
  "organizational_ids",
  "board_level_oversight",
  "countries_operation",
];
const riskKeys = [
  "identify_risk",
  "financial_impact",
  "no_financial_impact",
  "capitalized_costs",
  "expenses_losses",
  "transition_plan",
  "physical_transition_risks",
  "joint_ventures",
  "products_and_services",
  "investment",
  "operations",
];
const strategyKeys = [
  "climate_plan",
  "scenario_analysis",
  "carbon_offsets",
  "carbon_offsets_certified",
  "carbon_offsets_approved",
  "contractual_instruments",
  "sold_transferred_offsets",
  "scenarios",
  "parameters",
  "assumptions",
];
const energyKeys = [
  "consumption_fuel",
  "consumption_electricity",
  "generation_all",
];
const challengesKeys = ["challenges"];
const targetKeys = ["emission_target_active", "no_emission_target_active"];
export const reportAutoFillAPISectioning = {
  intro: introKeys,
  risk: riskKeys,
  strategy: strategyKeys,
  target: targetKeys,
  energy: energyKeys,
  challenges: challengesKeys,
};

// ------------------------------ REPORTS FILL INITIAL STATE ------------------------------
const reportsDateTypeIS = {
  month: [],
  qtd: [],
  year: [],
  ytd: [],
  custom: {},
};
const reportsIntroIS = {
  approval: { dropdown: {}, input: "", input2: "" },
  company_description: { textArea: "" },
  reporting_boundary: { radio: "" },
  transport_modes: { checkbox: [] },
  organizational_ids: [{ dropdown: {}, input: "" }],
  board_level_oversight: { radio: "", textArea: "" },
  countries_operation: { dropdown: [] },
};
const reportsRiskIS = {
  identify_risk: { radio: "" },
  financial_impact: { radio: "", textArea: "" },
  no_financial_impact: { radio: "" },
  capitalized_costs: { radio: "" },
  expenses_losses: { radio: "" },
  transition_plan: { radio: "", textArea: "" },
  physical_transition_risks: { radio: "", textArea: "" },
  products_and_services: { checkbox: [], textArea: "" },
  investment: { checkbox: [], textArea: "" },
  operations: { checkbox: [], textArea: "" },
  joint_ventures: { radio: [], textArea: "" },
};
const reportsStrategyIS = {
  climate_plan: { radio: "", textArea: "" },
  scenario_analysis: { radio: "", textArea: "" },
  scenarios: { checkbox: [], textArea: "" },
  parameters: { checkbox: [], textArea: "" },
  assumptions: { checkbox: [], textArea: "" },
  carbon_offsets: { radio: "", textArea: "" },
  carbon_offsets_certified: { radio: "", textArea: "" },
  carbon_offsets_approved: { radio: "", textArea: "" },
  contractual_instruments: { radio: "", textArea: "" },
  sold_transferred_offsets: { radio: "", textArea: "" },
};
const reportsTargetIS = {
  emission_target_active: { radio: "", textArea: "" },
  no_emission_target_active: { radio: "", textArea: "" },
};
const reportsEnergyIS = {
  consumption_fuel: yesNoOtherDropdownOptions?.slice(0, 1),
  consumption_electricity: yesNoOtherDropdownOptions?.slice(0, 1),
  generation_all: yesNoOtherDropdownOptions?.slice(1, 2),
};
const reportsChallengesIS = {
  challenges: { radio: "", textArea: "" },
};
export const reportsInitialStateFill = {
  date: reportsDateTypeIS,
  intro: reportsIntroIS,
  risk: reportsRiskIS,
  strategy: reportsStrategyIS,
  target: reportsTargetIS,
  energy: reportsEnergyIS,
  challenges: reportsChallengesIS,
};
